import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const doLogin = createAsyncThunk(
  "auth/doLogin",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("admin/login", data);

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Server error");
    }
  }
);

export const loginWithOtp = createAsyncThunk(
  "auth/loginWithOtp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(`/admin/login-with-otp`, data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Server error");
    }
  }
);

const loginSlice = createSlice({
  name: "login",
  initialState: {
    loading: false,
    loginDetails:null,
  },
  reducers: {
    resetStatus: (state) => {
      state.loading = false;
    },
    setLoginDetails: (state, action) => {
      state.loginDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(doLogin.pending, (state) => {
      state.loading = true;
    })
    .addCase(doLogin.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(doLogin.rejected, (state) => {
      state.loading = false;
    })
    .addCase(loginWithOtp.pending, (state) => {
      state.loading = true;
    })
    .addCase(loginWithOtp.fulfilled, (state, action) => {
      state.loading = false;
    })
    .addCase(loginWithOtp.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { resetStatus, setLoginDetails } = loginSlice.actions;
export default loginSlice.reducer;
